export const calendarStyles = {
  mainContainer: "flex flex-col flex-grow mt-4 bg-msc-white rounded-[1.5rem] border border-slate-200 shadow-lg h-auto lg:h-[calc(100vh-270px)] min-h-[450px] overflow-hidden",
  navBar: "relative flex justify-start lg:justify-center items-center p-4 sm:p-5 border-b border-slate-100 bg-msc-white",
  monthTitle: "text-lg sm:text-2xl font-black text-msc-dark capitalize tracking-tighter flex items-center",
  yearLabel: "lowercase text-slate-400 font-normal mx-1",
  controlsWrapper: "absolute right-4 sm:right-6 flex gap-1 bg-slate-100 p-1 rounded-xl",
  navBtn: "p-1 sm:p-2 hover:bg-msc-white rounded-lg transition-all text-msc-dark/60 hover:text-msc-dark",
  weekHeader: "grid grid-cols-7 bg-slate-50/80 border-b border-slate-100",
  weekDayLabel: "py-2 text-center text-[8px] sm:text-[10px] font-black uppercase tracking-widest text-slate-400",
  grid: "grid grid-cols-7 grid-rows-6 flex-grow divide-x divide-y divide-slate-100 bg-slate-100 overflow-hidden",

  cell: (currentMonth, isPast, isSelected) => `
    relative p-1 sm:p-3 flex flex-col h-full min-h-[60px] sm:min-h-0 transition-all duration-200 
    ${!currentMonth ? 'bg-slate-50/50 text-slate-300' : 'bg-msc-white'}
    ${isPast && currentMonth ? 'grayscale opacity-40 cursor-default' : 'cursor-pointer hover:bg-slate-50/80'}
    ${isSelected ? 'z-10 ring-2 ring-inset' : ''}
  `,

  dayNumber: (isToday, currentMonth) => `
    text-sm sm:text-2xl font-black tracking-tighter leading-tight
    ${!currentMonth ? 'text-slate-200' : 'text-msc-dark'}
  `,
  
  indicatorBar: (color, isSelected) => `
    h-1 sm:h-1.5 rounded-full mb-0.5 sm:mb-1 transition-all duration-500 
    ${color} ${isSelected ? 'w-full' : 'w-2 sm:w-4'}
  `,
  
  indicatorText: (color) => `
    hidden sm:block text-[9px] font-black uppercase tracking-tighter truncate ${color}
  `,

  actionBtn: (color) => `
    w-full py-0.5 sm:py-1 px-0.5 rounded-md text-[5px] sm:text-[8px] font-black uppercase text-msc-white 
    shadow-sm transition-all active:scale-95 leading-tight flex items-center justify-center text-center
    ${color} disabled:opacity-50 mt-auto
  `
};